import React, { Component } from 'react';
import UtilService from "../../services/util.service";
import PlatformType from "../../enums/PlatformType"

import { SCRIPTS } from "../../constants/staticScripts";

const PaymentReceipts = ({ message, showPopup, template_name, handleUserAction, messageTime }) => {
    let data = message
    try {
        data = JSON.parse(data)
    }
    catch (e) {
        data = undefined
    }
    let receipts = data ? data : undefined;



    let display_keys = {
        paymentDate: 'Payment Date',
        time: 'Time',
        name: 'Name',
        accountNumber: 'Account Number',
        mobileNumber: 'Mobile Number',
        payVia: 'Pay Via',
        amountPaid: 'Amount Paid'
    }

    const viewReceiptClick = (receipt) => {
        showPopup(
            <div>
                <p className="pull-right cursor-pointer" onClick={() => {
                    showPopup()
                }}><img src={`${process.env.PUBLIC_URL}/assets/images/outlined-cross.svg`} width="15" /></p>
                <p className="fs-20 color-dark-grey">
                    Payment Receipt
                </p>
                <div className="payment-page body-white">
                    {Object.keys(receipt).map((detail_name, index) => {
                        if (detail_name === 'amountPaid') {
                            return (
                                <div key={index} className="display-flex pull-left width-full pt-10 pb-70">
                                    <p className="pull-left pl-10 fs-bold width-50percent">{display_keys[detail_name] ? display_keys[detail_name] : detail_name}</p>
                                    <p className="pull-right pr-10 fs-bold">{receipt[detail_name]}</p>
                                </div>
                            )
                        }
                        else {
                            return (
                                <div key={index} className="border-bottom-grey pt-10 pb-10 width-50percent pull-left">
                                    <p className="pl-10 fs-14 color-dark-grey"><span className="display-block fs-9 color-grey">{display_keys[detail_name] ? display_keys[detail_name] : detail_name}</span>{receipt[detail_name]}</p>
                                </div>
                            )
                        }
                    })}

                    {/* <a class="download-button" href="#">DOWNLOAD</a> */}
                </div>
            </div>, '100vh', '100vw'
        )
    }

    return (
        <div id={`plans_scroll_${messageTime.timestamp}`} style={{ alignItems: 'center', display: 'flex' }} className={`monthly-plan monthly-plan-scroll ${(false && receipts && receipts.length > 1) ? 'pl-10' : 'monthly-plan-single pl-67'}`} >
            {!receipts && <ul className="bubbles relate pl-67 relate-0" ><li><p>{SCRIPTS.NO_SYSTEM_INFO_MESSAGE}</p></li></ul>}
            {(UtilService.getPlatformType() === PlatformType.WEB) && receipts && receipts.length > 0 && <div className="carousel_web_arrows">
                <div><button className="arrow_button_left"
                    onClick={() => {
                        UtilService.startScrollingLeft(`plans_scroll_${messageTime.timestamp}`);
                    }}
                >&#8249;</button></div>
                <div><button className="arrow_button_right"
                    onClick={() => {
                        UtilService.startScrollingRight(`plans_scroll_${messageTime.timestamp}`);
                    }}
                >&#8250;</button></div>
            </div>}
            {receipts && receipts.length > 0 && <ul className="carousel_list">
                {receipts && receipts.map((receipt, index) => {
                    return (
                        <li key={index} className="monthly_plan_item">
                            <div
                                className=" plan-details color-black" style={{ height: '200px' }}>
                                <span className="fs-8 display-block color-grey pl-10  pt-15">RECEIPT</span>

                                <span className="fs-20 display-block color-dark-grey  pl-10">Rs. {receipt.amountPaid}</span>
                                <span className="line" />
                                <ul className="benifits">
                                    <li >{'Mobile Number ' + receipt.mobileNumber}</li>
                                    <li >{'Account Number ' + receipt.accountNumber}</li>
                                    <li >{'Payment Date '}<br></br>{receipt.paymentDate}</li>
                                </ul>
                                <button onClick={() => {
                                    viewReceiptClick(receipt)
                                }}
                                    className=" cursor-pointer billplan-card-links color-link fs-12 display-block  activate">VIEW RECEIPT</button>
                            </div>
                        </li>
                    )
                })}

            </ul>}
            {receipts && receipts.length === 0 && <ul className="bubbles relate pl-67 relate-0" ><li><p>{SCRIPTS.NO_RECEIPTS}</p></li></ul>}
        </div>
    );
}

export default PaymentReceipts;


// WEBPACK FOOTER //
// ./src/components/message-components/payment-receipts.component.js